<template>
  <div class="fileContainer">
    <div class="bg-purple-7 q-pa-sm justify-between row text-white file-param">
      <default-sizes v-on:defaultSize="setDefaultSize" />
      <q-btn
        flat
        icon="cancel"
        dense
        color="red"
        style="background: #DDDDDD"
        @click="deleteThisFile"
      />
    </div>
    <div
      class="file-param"
      v-bind:class="{ row: $q.screen.gt.sm, 'no-wrap': $q.screen.gt.sm }"
    >
      <div class="lt-md q-mb-lg row file-param justify-center">
        <img :src="filePreview1" class="preview-image q-mt-lg" />
      </div>

      <div class="file-param" v-bind:class="{ 'col-6': $q.screen.gt.sm }">
        <q-card
          color="white"
          text-color="primary"
          v-bind:class="{ 'q-ma-lg': $q.screen.gt.sm }"
        >
          <q-card-title>
            Параметры печати
          </q-card-title>
          <q-card-separator />
          <q-list>
            <q-item>
              <q-item-side class="gt-md">
                <q-item-tile color="primary  q-display-2 text-bold"
                  >1</q-item-tile
                >
              </q-item-side>
              <q-item-main>
                <!-- <q-item-tile label>Размеры изображения</q-item-tile> -->
                <q-item-tile>
                  <div class="row no-wrap justify-between">
                    <q-input
                      name="file_width"
                      v-model="fileWidth"
                      stack-label="Ширина (м):"
                      class="param-input"
                      type="number"
                      inverted
                      color="positive"
                      autofocus
                      v-validate="{ required: true }"
                      style=" width:40%"
                    />
                    <q-btn
                      round
                      color="primary"
                      icon="import_export"
                      @click="switch_WH"
                      style="margin-top:10px; transform:rotate(90deg);"
                      class="q-ml-sm gt-xs"
                    />
                    <q-input
                      name="file_height"
                      v-model="fileHeight"
                      stack-label="Высота (м):"
                      class="param-input q-ml-sm"
                      inverted
                      color="positive"
                      v-validate="{ required: true }"
                      type="number"
                      style=" width:40%"
                    />
                  </div>
                </q-item-tile>
              </q-item-main>
            </q-item>

            <q-item>
              <q-item-side class="gt-md">
                <q-item-tile color="primary q-display-2 text-bold"
                  >2</q-item-tile
                >
              </q-item-side>
              <q-item-main>
                <q-item-tile>
                  <q-select
                    name="direction_field"
                    float-label="Вид работ"
                    v-model="fileDirection"
                    filter
                    autofocus-filter
                    inverted
                    :options="directions"
                    separator
                    v-validate="{ required: true }"
                    @input="directionInput"
                  />
                </q-item-tile>
              </q-item-main>
            </q-item>

            <q-item>
              <q-item-side class="gt-md">
                <q-item-tile color="primary  q-display-2 text-bold"
                  >3</q-item-tile
                >
              </q-item-side>

              <q-item-main>
                <q-item-tile>
                  <q-select
                    name="material_field"
                    float-label="Используемый материал"
                    v-model="fileMaterial"
                    placeholder="Выберите материал"
                    filter
                    autofocus-filter
                    inverted
                    :options="materialList"
                    separator
                    v-validate="{ required: true }"
                    class=""
                    @input="materialInput"
                  />
                </q-item-tile>
              </q-item-main>
            </q-item>

            <q-item>
              <q-item-side class="gt-md">
                <q-item-tile color="primary q-display-2 text-bold"
                  >4</q-item-tile
                >
              </q-item-side>
              <q-item-main>
                <q-item-tile>
                  <div class="quality_label" v-if="qualityList.length > 0">
                    Качество печати:
                  </div>
                  <q-btn-toggle
                    v-model="fileQuality"
                    toggle-color="positive"
                    :options="qualityList"
                    rounded
                    class="q-mb-md"
                  />
                </q-item-tile>
              </q-item-main>
            </q-item>

            <q-item>
              <q-item-side class="gt-md">
                <q-item-tile color="primary q-display-2 text-bold"
                  >5</q-item-tile
                >
              </q-item-side>
              <q-item-main>
                <post-type1 :fileParam="FileParam" />
              </q-item-main>
            </q-item>

            <q-card-separator class="q-mb-lg q-mt-lg" />

            <q-item>
              <q-item-side class="gt-md">
                <q-item-tile color="primary q-display-2 text-bold"
                  >6</q-item-tile
                >
              </q-item-side>
              <q-item-main>
                <q-item-tile>
                  <q-input
                    v-model.trim="fileTitle"
                    inverted
                    color="secondary"
                    float-label="Как подписать готовое изделие"
                    class="1comment-input"
                    @blur="saveParam"
                  />
                </q-item-tile>
              </q-item-main>
            </q-item>

            <q-item>
              <q-item-side class="gt-md">
                <q-item-tile color="primary q-display-2 text-bold"
                  >7</q-item-tile
                >
              </q-item-side>
              <q-item-main>
                <q-item-tile>
                  <q-input
                    name="file_comment"
                    id="file_comment"
                    float-label="Комментарии к файлу"
                    v-model.trim="fileComment"
                    color="secondary"
                    inverted
                    @blur="saveParam"
                  />
                </q-item-tile>
              </q-item-main>
            </q-item>

            <q-card-separator class="q-mb-lg q-mt-lg" />

            <q-item>
              <q-item-side class="gt-md">
                <q-item-tile color="primary q-display-2 text-bold"
                  >8</q-item-tile
                >
              </q-item-side>
              <q-item-tile>
                <div class="q-ml-sm q-title">
                  Дополнительные работы
                </div>
              </q-item-tile>
            </q-item>

            <q-item>
              <q-item-side class="gt-md">
                <q-item-tile
                  color="primary q-display-2 text-bold"
                ></q-item-tile>
              </q-item-side>
              <q-item-main>
                <div
                  class=" row no-wrap q-ml-sm q-pa-sm ellipsis extWork items-baseline"
                >
                  <q-input
                    float-label="Вид работ"
                    v-model.trim="editExtWork.name"
                    color="secondary"
                    class="q-ma-xs"
                  />

                  <q-input
                    float-label="Стоимость"
                    v-model.trim="editExtWork.cost"
                    color="secondary"
                    type="number"
                    align="left"
                    class="q-ma-xs"
                    style="width:80px"
                  />
                  <q-checkbox
                    v-model="editExtWork.eachNumber"
                    label="Каждый"
                    class="q-ma-xs"
                  />
                  <!-- isEditExtWork -->
                  <q-btn
                    icon="add"
                    class="q-ml-lg"
                    color="positive"
                    v-if="!isEditExtWork"
                    @click="updateExtWork"
                  />
                  <q-btn
                    icon="save"
                    class="q-ml-lg"
                    color="positive"
                    v-if="isEditExtWork"
                    @click="updateExtWork"
                  />
                  <q-btn
                    icon="cancel"
                    class="q-ml-xs"
                    color="negative"
                    outline
                    v-if="isEditExtWork"
                    @click="updateExtWork"
                  />
                </div>
              </q-item-main>
            </q-item>
            <q-item-separator />
            <div v-for="(item, key) in extendedWorkList" :key="key">
              <q-item class="myExtWorkLine ellipsis bg-grey-3">
                <q-item-side class="gt-md">
                  <q-item-tile
                    color="primary q-display-2 text-bold"
                  ></q-item-tile>
                </q-item-side>
                <q-item-side
                  class="row no-wrap"
                  style="width:9%; min-width:50px"
                >
                  <q-item-tile
                    ><q-btn
                      icon="delete"
                      flat
                      dense
                      color="negative"
                      class=""
                      @click="deleteExtWork(item)"
                  /></q-item-tile>
                  <q-item-tile
                    ><q-btn
                      icon="edit"
                      flat
                      dense
                      color="primary"
                      class="q-ml-xs"
                      @click="setEditExtWork(item)"
                  /></q-item-tile>
                </q-item-side>

                <q-item-side>
                  <q-item-tile
                    ><div
                      class="q-ma-xs ellipsis"
                      style="width:40%; min-width:150px"
                    >
                      {{ item.name }}
                    </div></q-item-tile
                  >
                </q-item-side>

                <q-item-side>
                  <q-item-tile
                    ><div class="q-ma-xs" style="width:10%; min-width:80px">
                      {{ item.cost }} р.
                    </div></q-item-tile
                  >
                </q-item-side>

                <q-item-side>
                  <q-item-tile>
                    <div class="q-ma-xs ellipsis" v-if="item.eachNumber">
                      К каждому
                    </div>
                    <div class="q-ma-xs ellipsis" v-if="!item.eachNumber">
                      Ко всему
                    </div>
                  </q-item-tile>
                </q-item-side>
              </q-item>
            </div>
            <q-item-separator />
          </q-list>
        </q-card>
      </div>

      <!-- Правый край -->

      <div
        v-bind:class="{ 'col-6': $q.screen.gt.sm, 'q-mt-lg': $q.screen.lt.md }"
      >
        <div class="gt-sm q-mt-lg row justify-center">
          <img :src="filePreview1" class="preview-image" />
        </div>

        <q-card
          color="white"
          text-color="primary"
          v-bind:class="{ 'q-ma-lg': $q.screen.gt.sm }"
        >
          <q-card-title>
            Расчет стоимости и количество
          </q-card-title>
          <q-card-separator class="q-mb-sm" />
          <q-item>
            <q-item-main>
              <q-item-tile>
                <div class="row no-wrap items-center q-mb-lg">
                  <div class="col-5 row no-wrap justify-around">
                    <div class="text-center">
                      <div class="q-caption">
                        Цена печати за кв.м.
                      </div>
                      <div
                        class="q-title q-mt-sm justify-center row"
                        v-on:dblclick="changePriceForMeter()"
                      >
                        {{ printForMeterCost }}

                        <q-popup-edit
                          v-model="printForMeterCost"
                          title="Цена за кв.м."
                          buttons
                          v-if="
                            $store.getters.isAllowPermission('print-terminal')
                          "
                          @save="saveNewPrice"
                        >
                          <div v-if="$store.getters.isAllowPermission('*')">
                            <q-input
                              type="number"
                              v-model="printForMeterCost"
                              @change="saveNewPrice"
                            />
                          </div>
                          <div v-if="!$store.getters.isAllowPermission('*')">
                            <div class="q-caption text-primary q-mt-sm">
                              Скидка в {{ discont }}% от прайсовой цены
                            </div>
                            <q-slider
                              v-model="discont"
                              :min="0"
                              :max="5"
                              :step="1"
                              label-always
                              snap
                            />
                            <div
                              class="row no-wrap justify-center text-primary text-center q-title"
                            >
                              Новая цена: {{ printForMeterCost }}
                            </div>
                          </div>
                        </q-popup-edit>
                      </div>
                    </div>
                  </div>
                  <div class="col-2 text-center">
                    <q-btn
                      icon="reply"
                      color="positive"
                      round
                      @click="setPriceCost"
                    />
                  </div>
                  <div class="col-5 text-center">
                    <div class="q-caption grey-2">
                      Цена по прайсу за кв.м.
                    </div>
                    <div class="q-title q-mt-sm ">
                      {{ printPrice }}
                    </div>
                  </div>
                </div>
              </q-item-tile>
            </q-item-main>
          </q-item>
          <q-card-separator />
          <q-item>
            <q-item-main>
              <q-item-tile>
                <div class="q-caption text-grey-7 text-left">
                  Стоимость печати:
                </div>
                <div class="q-subheading grey-2 ellipsis  text-left">
                  {{ fileWidth }} x {{ fileHeight }} х {{ printForMeterCost }} x
                  {{ fileNumber }} = {{ printItog }} р.
                </div>
              </q-item-tile>
            </q-item-main>
          </q-item>

          <q-item>
            <q-item-main>
              <q-item-tile>
                <div class="q-caption text-grey-7 text-left">
                  Стоимость обработки:
                </div>
                <div
                  class="q-subheading grey-2 ellipsis  text-left row no-wrap"
                >
                  <div>
                    {{ onePost }}
                    <q-popup-edit
                      v-model="specialPost"
                      title="Общая стоимость обработки"
                      buttons
                      v-if="$store.getters.isAllowPermission('*')"
                    >
                      <div class="row no-wrap">
                        <q-input type="number" v-model="specialPost" />
                        <q-btn
                          dense
                          flat
                          color="red"
                          label="сбросить"
                          @click="dropSpecialPost"
                        />
                      </div>
                    </q-popup-edit>
                  </div>
                  <div class="q-ml-xs">
                    x {{ fileNumber }} = {{ postItog }} р.
                  </div>
                </div>
              </q-item-tile>
            </q-item-main>
          </q-item>
          <q-item>
            <q-item-main>
              <q-item-tile>
                <div class="q-caption text-grey-7 text-left">
                  Стоимость доп.работ:
                </div>
                <div class="q-subheading grey-2 ellipsis  text-left">
                  {{ extCost }} р.
                </div>
              </q-item-tile>
            </q-item-main>
          </q-item>

          <q-card-separator />
          <q-item>
            <q-item-main>
              <q-item-tile label>Количество:</q-item-tile>
              <q-item-tile>
                <q-input
                  v-model.trim="fileNumber"
                  inverted
                  type="number"
                  color="primary"
                  align="center"
                  :maxlength="8"
                  :min="0"
                  :decimals="0"
                  @input="checkCount"
                  style="font-size:30px;"
                />
              </q-item-tile>
            </q-item-main>
          </q-item>

          <q-card-separator class="q-mt-md" />

          <q-item>
            <q-item-main>
              <q-item-tile>
                <div class="itog-text itog-container">{{ costItog }} р</div>
                <div class="itog-text itog-title">Итого:</div>
              </q-item-tile>
            </q-item-main>
          </q-item>
        </q-card>
      </div>
    </div>

    <!-- </q-modal-layout> -->
  </div>
</template>

<script>
/* eslint-disable */
import defaultSizes from "../defaultSizes";
import postType1 from "./postType1";

export default {
  name: "mainDialogFile",

  components: {
    defaultSizes,
    postType1
  },

  props: {
    FileParam: {
      type: Object,
      requered: true
    },
    index: Number
  },

  data() {
    return {
      promDiscont: 0,
      stanok: 0,
      options: {},

      availableDirections: [1, 2], // список доступных направлений, которые обрабатывает этот диалог

      defaultOptions: {
        //Значения по умолчанию - после загрузки надо установить все эти значения по умолчанию
        width: 0,
        height: 0,
        stanok: 0,
        material: 0,
        quality: 0,
        title: "",
        comment: "",
        preview_1: "",
        number: 1
      },

      //  Старые параметры!!!!
      savedPrice: 0,
      printPrice: 0,
      isEditPrice: false,
      newPriceForMeter: 0,
      firstSet: false, // флаг для первой установки
      isCalc: false,
      postItog: 0,
      onePost: 0,
      extCost: 0,
      s: 0,
      printItog: 0,

      editExtWork: {
        id: -1,
        name: "",
        cost: null,
        eachNumber: false
      },
      isEditExtWork: false,

      defaultData: [
        // для случая, когда не задана обработка
        "postType1",
        [[], [], [], [], [], [], [], [], [], [], [], [], [], []],
        []
      ]
    };
  },

  created() {
    this.firstSet = false; // флаг для первой установки цены

    this.options =
      this.FileParam.options != undefined
        ? JSON.parse(this.FileParam.options)
        : this.defaultOptions;
    // this.options = JSON.parse(this.FileParam.options);

    // Устанавливаем значения по умолчанию
    for (var key in this.defaultOptions) {
      // console.log(key+' '+this.defaultOptions[key]);
      if (this.options[key] === undefined) {
        this.$set(this.options, key, this.defaultOptions[key]);
      }
    }
    if (this.FileParam.cost == 0) {
      this.firstSet = true;
    }
    this.isCalc = true;
  },

  computed: {
    discont: {
      get: function() {
        return this.promDiscont;
      },
      set: function(newValue) {
        this.promDiscont = newValue;
        this.specialPrice = 1; // ставим флаг, что цена специальная
        this.printForMeterCost = this.printPrice * (1 - newValue / 100);
      }
    },

    costItog() {
      if (!this.isCalc) return "";
      // нужно получить параметры файла
      var fileOptions =
        this.FileParam.options != undefined
          ? JSON.parse(this.FileParam.options)
          : this.defaultOptions;

      var s = fileOptions.width * fileOptions.height; //округляем до 2х знаков после запятой - это площадь

      this.s = s; // для отображения

      var p_item = this.$store.getters.getPrice(
        fileOptions.stanok,
        fileOptions.material,
        fileOptions.quality
      ); //получаем прайсовую цену за печать
      this.printPrice = p_item != undefined ? p_item.price : 0;
      var p = 0;

      // если в опциях к файлу не задана цена за кв.м. или она нулевая - пробуем установить цену по прайсу
      if (
        fileOptions.printForMeterCost == undefined ||
        fileOptions.printForMeterCost == 0
      ) {
        if (p_item != undefined) {
          // если есть прайсовая цена
          this.printForMeterCost = p_item.price;
        }
      }
      // if ((this.printPrice > 0)) {
      //     if (this.specialPrice == 0) this.printForMeterCost = this.printPrice; // если не стоит флаг специальной цены - то заменяем на прайсовую
      // }

      // //если ранее цена не устанавливалась - то ставим прайсовую и разрешаем менять.
      // // и если уже сохранялось - то только по нажатию кнопки
      if (this.firstSet && this.specialPrice == 0) {
        // this.FileParam.cost = this.printPrice; // устарело!!! потом нужно будет заменить чтобы это поле содержало итоговую стоимость
        this.printForMeterCost = this.printPrice; //устанавливаем цену печати за квадрат из прайса
      }
      // //Считаем обработку

      if (fileOptions.post != null) {
        var filePost = fileOptions.post; // Получили всю постобработку
        let post_cost = 0;
        // идем по всей постобработке
        for (var key in filePost) {
          for (var i = 0; i < filePost[key].length; i++) {
            //идем по всем значениям
            var p = this.$store.getters.getPostPrice(filePost[key][i]);
            if (p != undefined) {
              if (key == "space") {
                // если обработка по площади
                post_cost += fileOptions.width * fileOptions.height * p.cost;
              } else {
                //если по периметру
                let l = fileOptions.height;
                if (key == "top" || key == "bottom") l = fileOptions.width;
                post_cost += p.cost * l;
              }
            }
          }
        }
        this.postItog = Math.round(post_cost * 100) / 100;
      } else {
        // если нет никакой обработки
        this.postItog = 0;
      }
      // проверяем установлена ли спец-цена на обработку
      if (this.specialPost != null && this.specialPost > -1) {
        this.postItog = this.specialPost;
      }
      this.onePost = this.postItog;

      // считаем доп.работы
      if (fileOptions.extWork != null) {
        let prom = fileOptions.extWork;
        let extSumm = 0;
        prom.forEach(element => {
          extSumm += element.eachNumber
            ? element.cost * this.fileNumber
            : element.cost;
        });
        this.extCost = extSumm;
      } else this.extCost = 0;

      if (this.FileParam.cost == undefined) this.FileParam.cost = 0;

      // this.printItog = Math.round(s*this.FileParam.cost*this.fileNumber);
      this.printItog = Math.round(s * this.printForMeterCost * this.fileNumber);
      this.printCost = this.printItog;

      this.postItog = Math.round(this.postItog * this.fileNumber);
      this.postCost = this.postItog;

      this.FileParam.itogCost = this.printItog + this.postItog + this.extCost;
      this.FileParam.cost = this.FileParam.itogCost;
      return this.FileParam.cost;
    },

    fileId() {
      return this.FileParam.id;
    },

    extendedWorkList() {
      let f = this.$store.getters.getFileById(this.FileParam.id);
      let opt = f.options != undefined ? JSON.parse(f.options) : {};
      return opt.extWork != null ? opt.extWork : {};
    },

    fileNumber: {
      get: function() {
        let f = this.$store.getters.getFileById(this.FileParam.id);
        let opt =
          f.options != undefined ? JSON.parse(f.options) : this.defaultOptions;
        if (opt.number == undefined) {
          opt.number = this.defaultOptions.number;
          this.saveParam("number", opt.number);
        }
        return opt.number;
      },
      set: function(newValue) {
        this.saveParam("number", newValue);
      }
    },

    specialPost: {
      get: function() {
        let f = this.$store.getters.getFileById(this.FileParam.id);
        let opt =
          f.options != undefined ? JSON.parse(f.options) : this.defaultOptions;
        if (opt.specialPost == undefined) {
          opt.specialPost = -1;
          this.saveParam("specialPost", -1);
        }
        return opt.specialPost;
      },
      set: function(newValue) {
        this.saveParam("specialPost", newValue);
      }
    },

    postCost: {
      get: function() {
        let f = this.$store.getters.getFileById(this.FileParam.id);
        let opt =
          f.options != undefined ? JSON.parse(f.options) : this.defaultOptions;
        if (opt.postCost == undefined) {
          opt.postCost = 0;
          this.saveParam("postCost", 0);
        }
        return opt.postCost;
      },
      set: function(newValue) {
        this.saveParam("postCost", newValue);
      }
    },

    specialPrice: {
      get: function() {
        let f = this.$store.getters.getFileById(this.FileParam.id);
        let opt =
          f.options != undefined ? JSON.parse(f.options) : this.defaultOptions;
        if (opt.specialPrice == undefined) {
          opt.specialPrice = 0;
          this.saveParam("specialPrice", 0);
        }
        return opt.specialPrice;
      },
      set: function(newValue) {
        this.saveParam("specialPrice", newValue);
      }
    },

    printCost: {
      get: function() {
        let f = this.$store.getters.getFileById(this.FileParam.id);
        let opt =
          f.options != undefined ? JSON.parse(f.options) : this.defaultOptions;
        if (opt.printCost == undefined) {
          opt.printCost = 0;
          this.saveParam("printCost", 0);
        }
        return opt.printCost;
      },
      set: function(newValue) {
        this.saveParam("printCost", newValue);
      }
    },

    printForMeterCost: {
      // работаем с ценой печати за кв.м.
      get: function() {
        let f = this.$store.getters.getFileById(this.FileParam.id);
        let opt =
          f.options != undefined ? JSON.parse(f.options) : this.defaultOptions;
        if (opt.printForMeterCost == undefined) {
          opt.printForMeterCost = 0;
          this.saveParam("printForMeterCost", 0);
        }
        return opt.printForMeterCost;
      },
      set: function(newValue) {
        this.saveParam("printForMeterCost", newValue);
      }
    },

    filePreview1() {
      if (this.options != undefined) return this.options.preview_1;
      else return "";
    },

    fileQuality: {
      get: function() {
        let f = this.$store.getters.getFileById(this.FileParam.id);
        let opt =
          f.options != undefined ? JSON.parse(f.options) : this.defaultOptions;
        return opt.quality;
      },
      set: function(newValue) {
        this.saveParam("quality", newValue);
      }
    },

    fileMaterial: {
      get: function() {
        let f = this.$store.getters.getFileById(this.FileParam.id);
        let opt =
          f.options != undefined ? JSON.parse(f.options) : this.defaultOptions;
        return opt.material;
      },
      set: function(newValue) {
        this.saveParam("material", newValue);
      }
    },

    fileTitle: {
      get: function() {
        let f = this.$store.getters.getFileById(this.FileParam.id);
        let opt =
          f.options != undefined ? JSON.parse(f.options) : this.defaultOptions;
        return opt.title;
      },
      set: function(newValue) {
        this.saveParam("title", newValue);
      }
    },

    fileDirection: {
      get: function() {
        let f = this.$store.getters.getFileById(this.FileParam.id);
        let opt =
          f.options != undefined ? JSON.parse(f.options) : this.defaultOptions;
        return opt.stanok;
      },
      set: function(newValue) {
        this.saveParam("stanok", newValue);
      }
    },

    fileWidth: {
      get: function() {
        let f = this.$store.getters.getFileById(this.FileParam.id);
        let opt =
          f.options != undefined
            ? JSON.parse(f.options)
            : { width: 0, height: 0 };
        return opt.width;
      },
      set: function(newValue) {
        this.saveParam("width", newValue);
      }
    },

    fileHeight: {
      get: function() {
        let f = this.$store.getters.getFileById(this.FileParam.id);
        let opt =
          f.options != undefined
            ? JSON.parse(f.options)
            : { width: 0, height: 0 };
        // let opt = JSON.parse(f.options);
        return opt.height;
      },
      set: function(newValue) {
        this.saveParam("height", newValue);
      }
    },

    fileComment: {
      get: function() {
        let f = this.$store.getters.getFileById(this.FileParam.id);
        let opt =
          f.options != undefined ? JSON.parse(f.options) : this.defaultOptions;
        // let opt = JSON.parse(f.options);
        return opt.comment;
      },
      set: function(newValue) {
        this.saveParam("comment", newValue);
      }
    },

    directions() {
      var list = [];
      if (this.$store.getters.getAllDirections == undefined) return list;
      this.$store.getters.getAllDirections.map((value, key) => {
        let index = this.availableDirections.findIndex(item => {
          // проверяем на доступные направления
          return item == value.id;
        });
        if (index >= 0) list.push({ label: value.name, value: value.id });
      });
      return list;
    },

    materialList() {
      var list = [];
      if (this.$store.getters.getAllMaterials == undefined) return list;
      this.$store.getters.getAllMaterials.map((value, key) => {
        let q = JSON.parse(value.directions);
        if (q.indexOf(this.fileDirection) != -1) {
          // вставляем только те материалы, которые подходят под эту деятельсность
          list.push({ label: value.name, value: value.id });
        }
      });
      return list;
    },

    qualityList() {
      var list = [];
      var isOk = false;

      if (this.$store.getters.getAllQuality == undefined) return list;

      this.$store.getters.getAllQuality.map((value, key) => {
        let q = JSON.parse(value.directions);
        if (q.indexOf(this.fileDirection) != -1) {
          // вставляем только те значения, которые употребимы в данном виде деятельности
          list.push({ label: value.name, value: value.id });
          if (value.id == this.options.quality) isOk = true; // значит сохраненное в базе значение есть в списке кнопок
        }
      });

      if (!isOk) {
        // сохраненного значения качества печати почему то нет в с списке допустимых - задаем первый элемент из допустимых
        if (list.length > 0) {
          this.options.quality = list[0].value;
          this.saveParam("quality", list[0].value);
        }
      }

      return list;
    }
  },

  methods: {
    dropSpecialPost() {
      this.specialPost = -1;
    },

    setEditExtWork(w) {
      // скопируем в него все свойства
      for (var key in w) {
        this.editExtWork[key] = w[key];
      }
      // this.editExtWork = w;
      this.isEditExtWork = true;
    },

    deleteExtWork(w) {
      let f = this.$store.getters.getFileById(this.FileParam.id);
      let opt = f.options != undefined ? JSON.parse(f.options) : {};
      let ext = opt.extWork != null ? opt.extWork : [];

      let index = ext.findIndex(item => {
        return item.id == w.id;
      });
      ext.splice(index, 1);
      this.saveParam("extWork", ext); // сохраняем список.
    },

    emptyEditExtWork() {
      this.editExtWork.id = -1;
      this.editExtWork.name = "";
      this.editExtWork.cost = null;
      this.editExtWork.eachNumber = false;
    },

    updateExtWork() {
      if (this.editExtWork.name == "") {
        // нужно задать название
        this.$admns.showNotify("Задайте вид работ", "error", "проверка данных");
        return;
      }
      if (this.editExtWork.cost == null) {
        // нужно задать название
        this.$admns.showNotify(
          "Задайте стоимость работ",
          "error",
          "проверка данных"
        );
        return;
      }

      let f = this.$store.getters.getFileById(this.FileParam.id);
      let opt = f.options != undefined ? JSON.parse(f.options) : {};
      let ext = opt.extWork != null ? opt.extWork : [];

      if (this.editExtWork.id == -1) {
        // значит добавляем новый допник
        //нужно найти максимальный id
        let maxId = 0;
        ext.forEach(element => {
          if (element.id > maxId) maxId = element.id;
        });

        maxId += 1; // увеличиваем Id для нового элемента
        this.editExtWork.id = maxId;
        ext.push(this.editExtWork); // добавляем новый элемент в список
        this.saveParam("extWork", ext); // сохраняем список.
        this.emptyEditExtWork();
      } else {
        // значит якобы редактируем

        //ищем нужный индекс и заменяем элемент
        let index = ext.findIndex(item => {
          return item.id == this.editExtWork.id;
        });
        if (index > -1) {
          // если индекс нашелся - то хорошо, меняем. если не нашелся - то какой то косяк и ничего не делаем
          ext.splice(index, 1, this.editExtWork);
          this.saveParam("extWork", ext);
          this.emptyEditExtWork();
        }
      }
      this.isEditExtWork = false; // снимаем флажок редактирования
    },

    checkKey(key) {
      if (key.key == "Enter") {
        this.saveNewPrice();
      }
      if (key.key == "Esc") {
        this.isEditPrice = false;
        key.stopPropagation();
      }
    },

    saveNewPrice(price, oldPrice) {
      if (this.$store.getters.isAllowPermission("*")) {
        this.isEditPrice = false;
        this.specialPrice = 1; // ставим флаг, что цена специальная
        this.printForMeterCost = price;
      } else {
        this.isEditPrice = false;
        this.specialPrice = 1; // ставим флаг, что цена специальная
        this.printForMeterCost = price;
      }
    },

    changePriceForMeter() {
      this.newPriceForMeter = this.printForMeterCost;
      this.isEditPrice = true;
    },

    setPriceCost() {
      this.printForMeterCost = this.printPrice;
    },

    checkCount(newValue) {
      let q = "" + newValue;
      if (q.length >= 8) this.fileNumber = q.substring(0, 2) * 1;
    },

    emptyPost() {
      eventBus.$emit("emptyPost", this.FileParam.id); // событие на очистку постобработки
    },

    materialInput() {
      this.emptyPost();
    },

    directionInput() {
      // this.emptyPost();
    },

    saveParam(field, value) {
      let f = this.$store.getters.getFileById(this.FileParam.id);
      let opt = f.options != undefined ? JSON.parse(f.options) : [];
      opt[field] = value;
      f.options = JSON.stringify(opt);
      this.$store.commit("saveLocalFileParam", f);
    },

    switch_WH() {
      var p = this.fileWidth;
      this.fileWidth = this.fileHeight;
      this.fileHeight = p;
    },
    setDefaultSize(param) {
      this.fileWidth = param.width;
      this.fileHeight = param.height;
    },

    deleteThisFile() {
      // спрашиваем еще раз - точно ребята хотят удалить файл из заказа
      this.$q
        .dialog({
          title: "Внимание!",
          message: "Вы действительно хотите удалить файл из заказа?",
          ok: "Да, удалить",
          cancel: "Нет, я передумал",
          color: "primary"
        })
        .then(data => {
          this.$store.dispatch("deleteFileFromOrder", this.FileParam.id);
        })
        .catch(() => {
          //    console.log('отмена');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.myExtWorkLine {
  cursor: pointer;
  &:hover {
    background-color: rgb(195, 250, 195) !important;
  }
}
.extWork {
  border: 1px dotted rgb(139, 139, 139);
  border-radius: 3px;
}
.main_subtitle {
  font-size: 12px;
  color: gray;
}
.fileContainer {
  margin-top: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgb(212, 212, 212);
  padding: 10px;
}
.file-param {
  background: rgb(235, 235, 235);
}
.image-container {
  text-align: center;
}
.preview-image {
  padding: 10px;
  border: 1px solid rgb(212, 212, 212);
  background: white;
  max-width: 400px;
}
.param-input {
  color: black;
  background: white;
}
.comment-input {
  width: 100%;
  background: white;
  padding: 10px;
  margin-top: 10px;
}
.direction-select {
  clear: both;
  padding: 10px;
  margin-left: 10px;
  margin-bottom: 20px;
  width: 382px;
}

.quality-select {
  clear: both;
  margin-left: 10px;
  margin-bottom: 20px;
}
.quality_label {
  font-family: Arial, sans-serif;
  font-size: 15px;
  color: rgb(82, 82, 82);
  margin-left: 15px;
  margin-bottom: 5px;
}
.count-label {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 15px;
  float: left;
  margin-top: 33px;
  margin-left: 75px;
  margin-right: 0px;
  font-weight: bold;
  color: rgb(94, 94, 94);
}
.count-input {
  // max-width : 100px;
  margin: 25px;
  margin-right: 0px;
  float: left;
  font-size: 25px;
  font-weight: bold;
}
.divider {
  height: 2px;
  margin: 10px;
  margin-top: 40px;

  background: gray;
}
.itog-text {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 25px;
  color: green;
  font-weight: bold;
}
.itog-title {
  float: right;
  margin-top: 7px;
  margin-right: 10px;
}
.itog-container {
  font-size: 35px;
  text-align: right;
  float: right;
}
.count-container {
  min-height: 250px;
  height: auto;
  border: 1px dotted gray;
  min-width: 320px;
  max-width: 450px;
  width: 70%;
  border-radius: 5px;
  background: white;
}
</style>
